/**
 * Navigation
 * Update classes for current page
 */

export function highlightCurrentPage() {
  const pageSlug = document.querySelector("body").getAttribute("data-slug");
  const navItems = document.querySelectorAll(
    "header .nav-link, header .dropdown-menu a",
  );

  if (!pageSlug || !navItems.length) {
    return;
  }

  // Mark Active Nav Item
  navItems.forEach((el) => {
    const itemSlug = el.getAttribute("data-slug");
    if (pageSlug === itemSlug) {
      el.classList.add("current-page");
    }
  });
}
